"use client";

import Link from "next/link";
import { CareersBrowser as SharedCareersBrowser } from "@app-foundation/careers-ui";
import { ChevronRight } from "@app-foundation/icons/lucide";
import { careerPositions } from "./positions";
import styles from "./careers.module.css";

const locations = [...new Set(careerPositions.map(position => position.location))];
const positions = careerPositions.map(position => ({
  id: position.id, title: position.title, category: position.category, meta: position.location,
  searchText: [position.title, position.category, position.summary, ...position.introduction, ...position.details, ...position.responsibilities, ...position.requirements, ...position.bonuses].join(" "),
}));

export function CareersBrowser() {
  return <SharedCareersBrowser positions={positions} resultsHeading="h1"
    labels={{ filters: "职位筛选", search: "职位搜索", placeholder: "搜索职位关键词", categories: "职位类别", results: "职位列表", empty: "没有匹配的职位。", clearFilters: "清除筛选" }}
    classes={{ browser: styles.browser, filters: styles.filters, heading: styles.heading, search: styles.search, categories: styles.categories, filterRow: styles.filterRow, results: styles.results, empty: styles.empty }}
    filterExtra={<section className={styles.locations}><h2 className={styles.heading}>工作地点</h2><p className={styles.locationNote}>{locations.join(" / ")}</p></section>}
    renderPosition={position => <Link href={`/careers/${position.id}`} className={styles.position}><div><h2>{position.title}</h2><p>{position.category}<span aria-hidden="true"> | </span>{position.meta}</p></div><ChevronRight size={20} aria-hidden="true" /></Link>}
  />;
}
